import React, { useEffect, useState } from 'react'
import productServices from '../../services/ProductsServices'
import Empty from '../feedback/Empty'
import moment from 'moment'
import { BiSolidAddToQueue } from "react-icons/bi";
import ProductTypeModal from './ProductTypeModal'

function CaetgoriesList() {
    const [productTypes, setProductTypes] = useState()
    const [action, setAction] = useState(0)
    const [activeProductType, setActiveProductType] = useState()

    useEffect(() => {
        getProductTypes()
    }, [])

    const getProductTypes = () => {
        productServices.getProductTypes().then(
            res => {
                setProductTypes(res.data)
            },
            err => {
                console.log(err);

            }
        )
    }

    function openModal(action, pType){
      const openBtn = document.getElementById("product-type-open-btn")
      if (action === 0) {
        setAction(0)
      }
      if (action === 1) {
        setAction(1)
        setActiveProductType(pType)
      }
      openBtn.click()
    }
    return (
        <details className="collapse collapse-arrow bg-white dark:bg-slate-800 rounded-lg shadow-sm overflow-hidden border border-border-light dark:border-border-dark">
            <summary className="collapse-title font-semibold">Category List <span className='ml-3 text-gray-600'>{"("}{productTypes?.length || 0}{")"}</span></summary>
            <div className="collapse-content border-t pt-3">
                <div className=''>
                    <ProductTypeModal
                        action={action}
                        activeProductType={activeProductType}
                        getProductTypes={getProductTypes}
                    />
                    <div className="mb-3">
                        <div className="flex justify-end items-center">
                            <button
                                onClick={() => openModal(0)}
                                className='btn btn-primary btn-sm'><BiSolidAddToQueue className='h-4 w-4 mr-2' /> Add Category</button>
                        </div>
                        {productTypes?.length ? (
                            <div className='overflow-x-auto mt-3'>
                                <table className="table table-compact table-zebra w-full">
                                    <thead>
                                        <tr>
                                            <th className='hidden md:table-cell'>Image</th>
                                            <th>Name</th>
                                            <th>Product Count</th>
                                            <th className='hidden md:table-cell'>Created</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productTypes?.map((pType, idx) => (
                                            <tr key={idx}>
                                                <td className='hidden md:table-cell'>
                                                    {pType?.image ? (
                                                        <img
                                                            src={pType?.image}
                                                            alt="product type"
                                                            className='rounded-md h-14' />
                                                    ) : (
                                                        <div className="avatar placeholder">
                                                            <div className="bg-neutral text-white text-lg rounded-md h-9 w-9">
                                                                {String(pType?.name).charAt(0).toLocaleUpperCase()}
                                                            </div>
                                                        </div>
                                                    )}
                                                </td>
                                                <td className='font-bold'>
                                                    {pType?.name}
                                                </td>
                                                <td>
                                                    {pType?.product_count}
                                                </td>
                                                <td className='hidden md:table-cell'>
                                                    {moment(pType?.creation_time).format("MMM Do YYYY")}
                                                </td>
                                                <td>
                                                    <button
                                                        onClick={() => openModal(1, pType)}
                                                        className='btn btn-sm btn-primary'>View</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <Empty objectName={"Product Types"} />
                        )}
                    </div>
                </div>
            </div>
        </details>
    )
}

export default CaetgoriesList